import React from "react";
import { Route } from "react-router-dom";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import PreEpShell from "@/modules/hub/features/PreEpWelcome/components/PreEpShell/PreEpShell";
import PreEpStepsPage from "@/modules/hub/features/PreEpWelcome/components/PreEpStepsPage/PreEpStepsPage";
import PreEpEventChoice from "@/modules/hub/features/PreEpWelcome/components/PreEpEventChoice/PreEpEventChoice";
import PreEpSessionChoice from "@/modules/hub/features/PreEpWelcome/components/PreEpSessionChoice/PreEpSessionChoice";

/**
 * A Pre-EP member's Hub+: the getting-started steps and the EP / welcome
 * session pickers, full screen. Checkout itself stays under
 * /event-registration (CheckoutLayout, themed navy for them).
 */
const PreEpRoutes = (
  <Route
    element={<AuthenticationGuard component={PreEpShell} />}
    path="/pre-ep"
  >
    <Route element={<PreEpStepsPage />} index />
    <Route element={<PreEpEventChoice />} path="register/:step" />
    <Route
      element={<PreEpSessionChoice />}
      path="register/:step/events/:eventUuid"
    />
  </Route>
);

export default PreEpRoutes;
